import { ImageUrlDto, ImageUrlMapDto } from '../common/interfaces';
import httpClient from './HttpClient';

export class ImageUrlsClient {
    public static async generateImageUrls(imageUrls: ImageUrlDto[]): Promise<ImageUrlMapDto> {
        const response = await httpClient.post<ImageUrlMapDto, ImageUrlDto[]>(`/imageurls`, imageUrls);
        return response.data;
    }
}
